var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4291 0.277222C26.209 0.0454104 25.9073 -0.09375 25.5945 -0.09375H6.86976C3.41456 -0.09375 0.5625 2.74695 0.5625 6.20179V41.6104C0.5625 45.0656 3.41456 47.9063 6.86976 47.9063H32.2841C35.7393 47.9063 38.5914 45.0656 38.5914 41.6104V13.4945C38.5914 13.1931 38.4522 12.9035 38.2552 12.683L26.4291 0.277222ZM26.7653 3.99903L34.6843 12.312H29.5364C28.006 12.312 26.7653 11.083 26.7653 9.55263V3.99903ZM32.2841 45.5875H6.86976C4.70179 45.5875 2.88135 43.7905 2.88135 41.6104V6.20179C2.88135 4.03382 4.69007 2.2251 6.86976 2.2251H24.4465V9.55263C24.4465 12.3699 26.7192 14.6309 29.5364 14.6309H36.2725V41.6104C36.2725 43.7905 34.4638 45.5875 32.2841 45.5875Z",
    fill: "#D3B36E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1184 37.5876H10.0344C9.39685 37.5876 8.875 38.1091 8.875 38.7471C8.875 39.3846 9.39685 39.9065 10.0344 39.9065H29.1302C29.7677 39.9065 30.2896 39.3846 30.2896 38.7471C30.2896 38.1091 29.7677 37.5876 29.1184 37.5876Z",
    fill: "#D3B36E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.64 25.1122L18.4169 19.9757V32.6368C18.4169 33.2743 18.9387 33.7962 19.5763 33.7962C20.2142 33.7962 20.7357 33.2743 20.7357 32.6368V19.9757L25.5126 25.1122C25.7444 25.3554 26.0462 25.4832 26.3589 25.4832C26.6372 25.4832 26.9273 25.3788 27.1474 25.1701C27.6113 24.7295 27.6461 23.9989 27.2056 23.5353L20.4113 16.2426C20.1908 16.0107 19.8894 15.8716 19.5649 15.8716C19.2401 15.8716 18.9387 16.0107 18.7186 16.2426L11.9243 23.5353C11.4838 23.9989 11.5185 24.7409 11.9822 25.1701C12.4692 25.6106 13.1995 25.5758 13.64 25.1122Z",
    fill: "#D3B36E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.658d8861519baff03ab5f44ab9bbf773.svg";
export { ForwardRef as ReactComponent };